import { useAppDispatch } from '@store/hooks';
import { showNotification } from '@store/slices/globalnotification';

export const useNotification = () => {
  const dispatch = useAppDispatch();

  const showError = (errorMessages: string) => {
    dispatch(
      showNotification({
        type: 'error',
        title: 'Error',
        subtitle: `${errorMessages}`,
      })
    );
  };

  const showSuccess = (message: string) => {
    dispatch(
      showNotification({
        type: 'success',
        title: 'Success',
        subtitle: message,
      })
    );
  };

  const showInfo = (message: string) => {
    dispatch(
      showNotification({
        type: 'info',
        title: '',
        subtitle: message,
      })
    );
  };

  return { showError, showSuccess, showInfo };
};
